@if (hasHistory) {
  <button
    mat-icon-button
    data-tour-anchor="contract.history"
    (click)="showValidationRequests()"
    [matTooltip]="'Voir l\'historique (x' + historyCount + ')'"
  >
    <mat-icon class="info">history</mat-icon>
  </button>
}
